import { Map, List, fromJS } from 'immutable'
import { handleActions, combineActions } from 'redux-actions'
import moment from 'moment'
import ActionHelper from 'helpers/action'
import { TYPE_PEW, CHART_TYPE_SENSORS } from 'helpers/environmentMonitor'

// constants
export const SET_ACTIVE_VIEW_TYPE = 'environmentMonitor/SET_ACTIVE_VIEW_TYPE'
export const SET_ACTIVE_CHART_TYPE = 'environmentMonitor/SET_ACTIVE_CHART_TYPE'
export const FETCH_PEW_FORECAST_LIST =
  'environmentMonitor/FETCH_PEW_FORECAST_LIST'
export const SUCCEEDED_FETCH_PEW_FORECAST_LIST =
  'environmentMonitor/SUCCEEDED_FETCH_PEW_FORECAST_LIST'
export const FAILED_FETCH_PEW_FORECAST_LIST =
  'environmentMonitor/FAILED_FETCH_PEW_FORECAST_LIST'
export const FETCH_HISTORICAL_DATA = 'environmentMonitor/FETCH_HISTORICAL_DATA'
export const SUCCESS_HISTORICAL_DATA =
  'environmentMonitor/SUCCESS_HISTORICAL_DATA'
export const FAIL_HISTORICAL_DATA = 'environmentMonitor/FAIL_HISTORICAL_DATA'
export const FETCH_FORECAST_DATA = 'environmentMonitor/FETCH_FORECAST_DATA'
export const SUCCESS_FORECAST_DATA = 'environmentMonitor/SUCCESS_FORECAST_DATA'
export const FAIL_FORECAST_DATA = 'environmentMonitor/FAIL_FORECAST_DATA'
export const SET_LIST_FORECAST_DATA =
  'environmentMonitor/SET_LIST_FORECAST_DATA'
export const SET_LIST_HISTORY_DATA = 'environmentMonitor/SET_LIST_HISTORY_DATA'
export const FETCH_VISIBILITY_DATA = 'environmentMonitor/FETCH_VISIBILITY_DATA'
export const SUCCEEDED_VISIBILITY_DATA =
  'environmentMonitor/SUCCEEDED_VISIBILITY_DATA'
export const FAIL_VISIBILITY_DATA = 'environmentMonitor/FAIL_VISIBILITY_DATA'
export const RESET_CHART_DATA = 'environmentMonitor/RESET_CHART_DATA'
export const RESET_HISTORICAL_DATA = 'environmentMonitor/RESET_HISTORICAL_DATA'
export const RESET_FORECAST_DATA = 'environmentMonitor/RESET_FORECAST_DATA'
export const RESET_VISIBILITY_DATA = 'environmentMonitor/RESET_VISIBILITY_DATA'
export const LOG_MONITOR_ACTIVITY = 'environmentMonitor/LOG_MONITOR_ACTIVITY'

// actions
export const setActiveViewType = ActionHelper.createActionObj(
  SET_ACTIVE_VIEW_TYPE,
)
export const setActiveChartType = ActionHelper.createActionObj(
  SET_ACTIVE_CHART_TYPE,
)
export const fetchPewForecastList = ActionHelper.createActionObj(
  FETCH_PEW_FORECAST_LIST,
)
export const fetchHistoricalData = ActionHelper.createActionObj(
  FETCH_HISTORICAL_DATA,
)
export const fetchForecastData = ActionHelper.createActionObj(
  FETCH_FORECAST_DATA,
)
export const setListForecastData = ActionHelper.createActionObj(
  SET_LIST_FORECAST_DATA,
)
export const setListHistoryData = ActionHelper.createActionObj(
  SET_LIST_HISTORY_DATA,
)
export const fetchVisibilityData = ActionHelper.createActionObj(
  FETCH_VISIBILITY_DATA,
)
export const resetChartData = ActionHelper.createActionObj(RESET_CHART_DATA)
export const resetHistoricalData = ActionHelper.createActionObj(
  RESET_HISTORICAL_DATA,
)
export const resetForecastData = ActionHelper.createActionObj(
  RESET_FORECAST_DATA,
)
export const resetVisibilityData = ActionHelper.createActionObj(
  RESET_VISIBILITY_DATA,
)
export const logMonitorActivity = ActionHelper.createActionObj(
  LOG_MONITOR_ACTIVITY,
)

const initialState = fromJS({
  viewType: TYPE_PEW,
  chartType: CHART_TYPE_SENSORS,
  pewForecastList: [],
  temperatureData: [],
  oxygenData: [],
  speedData: [],
  tideData: [],
  chartData: {
    loader: true,
    data: [],
    dataView: {
      min: 0,
      max: 0,
      avg: 0,
      std: 0,
    },
  },
  visibilityData: {
    loader: true,
    min: null,
    max: null,
    avg: null,
  },
  listForecastData: {
    time: moment(),
    value: 0,
  },
  listHistoryData: {
    time: moment(),
    data: [
      {
        label: '5m',
        time: moment(),
        value: 0,
      },
    ],
  },
})

const environmentMonitor = handleActions(
  {
    [SET_ACTIVE_VIEW_TYPE]: (state, action) =>
      state.set('viewType', action.payload),
    [SET_ACTIVE_CHART_TYPE]: (state, action) =>
      state.set('chartType', action.payload),
    [SUCCEEDED_FETCH_PEW_FORECAST_LIST]: (state, action) =>
      state.set('pewForecastList', List(action.payload)),
    [FETCH_HISTORICAL_DATA]: state =>
      state.setIn(['chartData', 'loader'], true),
    [SUCCESS_HISTORICAL_DATA]: (state, action) =>
      state
        .set('chartData', fromJS(action.payload))
        .setIn(['chartData', 'loader'], false),
    [FAIL_HISTORICAL_DATA]: state =>
      state
        .set('chartData', initialState.get('chartData'))
        .setIn(['chartData', 'loader'], false),
    [FETCH_FORECAST_DATA]: state => state.setIn(['chartData', 'loader'], true),
    [SUCCESS_FORECAST_DATA]: (state, action) =>
      state
        .set('chartData', fromJS(action.payload))
        .setIn(['chartData', 'loader'], false),
    [combineActions(FAIL_FORECAST_DATA, RESET_CHART_DATA)]: state =>
      state
        .set('chartData', initialState.get('chartData'))
        .setIn(['chartData', 'loader'], false),
    [SET_LIST_FORECAST_DATA]: (state, action) =>
      state.set('listForecastData', Map(action.payload)),
    [SET_LIST_HISTORY_DATA]: (state, action) =>
      state.set('listHistoryData', Map(action.payload)),
    [FETCH_VISIBILITY_DATA]: state =>
      state.setIn(['visibilityData', 'loader'], true),
    [SUCCEEDED_VISIBILITY_DATA]: (state, action) =>
      state
        .set('visibilityData', Map(action.payload))
        .setIn(['visibilityData', 'loader'], false),
    [combineActions(FAIL_VISIBILITY_DATA, RESET_VISIBILITY_DATA)]: state =>
      state
        .set('visibilityData', initialState.get('visibilityData'))
        .setIn(['visibilityData', 'loader'], false),
    [RESET_HISTORICAL_DATA]: state =>
      state.set('listHistoryData', initialState.get('listHistoryData')),
    [RESET_FORECAST_DATA]: state =>
      state.set('listForecastData', initialState.get('listForecastData')),
  },
  initialState,
)

export default environmentMonitor
